/*
 * Posture-prelanders USA (sections/mv-prelander-posture.liquid), 22 okt 2026.
 * Ranglijst uitklappen, uurbalken, sorteerbare tabel (+ tabbladen op mobiel), keuzehulp en
 * maatwijzer. Alle zichtbare tekst komt uit de sectie-instellingen (data-attributen), niet uit
 * dit bestand. Geen meetcode: de NL-meetlaag (__mvTrack) gaat niet mee naar de USA-store.
 */
(function () {
  "use strict";

  var MINDER_BEWEGING = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* ---------- ranglijst: nummer 4 en 5 tonen ---------- */
  function zetUitgeklapt(groep, open) {
    var knop = groep.querySelector("[data-mvpp-toggle]");
    groep.querySelectorAll("[data-mvpp-extra]").forEach(function (k) { k.hidden = !open; });
    if (!knop) return;
    knop.setAttribute("aria-expanded", open ? "true" : "false");
    var label = knop.querySelector("[data-label]");
    if (label) label.textContent = open ? knop.dataset.minder : knop.dataset.meer;
  }

  function kaarten(root) {
    root.querySelectorAll("[data-mvpp-cards]").forEach(function (groep) {
      var knop = groep.querySelector("[data-mvpp-toggle]");
      if (!knop || knop.dataset.mvppInit) return;
      knop.dataset.mvppInit = "1";
      knop.addEventListener("click", function () {
        zetUitgeklapt(groep, knop.getAttribute("aria-expanded") !== "true");
      });
    });
  }

  /* ---------- uurbalken: groeien zodra ze in beeld komen ----------
   * Kijk naar het spoor, niet naar de balk zelf: een balk op scaleX(0) heeft geen oppervlak en
   * komt dus nooit "in beeld" (dan bleven alle balken onzichtbaar). */
  function balken(root) {
    var sporen = root.querySelectorAll("[data-mvpp-chart] .mvpp-chart__spoor");
    if (!sporen.length || MINDER_BEWEGING.matches || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var balk = e.target.querySelector(".mvpp-chart__balk");
        if (balk) balk.classList.add("is-aan");
        obs.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    sporen.forEach(function (spoor) {
      var balk = spoor.querySelector(".mvpp-chart__balk");
      if (!balk || balk.classList.contains("is-wacht")) return;
      balk.classList.add("is-wacht");
      obs.observe(spoor);
    });
  }

  /* ---------- tabel: sorteren ---------- */
  function waarde(cel) {
    if (!cel) return 0;
    if (cel.dataset.sorteerWaarde) return parseFloat(cel.dataset.sorteerWaarde) || 0;
    var m = (cel.textContent || "").replace(/,/g, "").match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  function tabel(root) {
    root.querySelectorAll("[data-mvpp-table]").forEach(function (sectie) {
      if (sectie.dataset.mvppInit) return;
      sectie.dataset.mvppInit = "1";
      var tbl = sectie.querySelector("table");
      var tbody = tbl && tbl.tBodies[0];
      if (!tbody) return;
      var status = sectie.querySelector("[data-mvpp-status]");
      var knoppen = sectie.querySelectorAll("[data-sorteer]");
      var nu = { kolom: null, op: false };
      var actief = sectie.querySelector('[data-sorteer][aria-pressed="true"]');
      if (actief) nu = { kolom: actief.dataset.sorteer, op: actief.hasAttribute("data-op") };

      knoppen.forEach(function (knop) {
        knop.addEventListener("click", function () {
          var kolom = knop.dataset.sorteer;
          var op = nu.kolom === kolom ? !nu.op : knop.hasAttribute("data-op");
          var rijen = Array.prototype.slice.call(tbody.rows);
          rijen.sort(function (a, b) {
            var x = waarde(a.cells[kolom]), y = waarde(b.cells[kolom]);
            return op ? x - y : y - x;
          });
          rijen.forEach(function (r) {
            r.classList.remove("is-verplaatst");
            void r.offsetWidth;
            r.classList.add("is-verplaatst");
            tbody.appendChild(r);
          });
          nu = { kolom: kolom, op: op };
          knoppen.forEach(function (k) { k.setAttribute("aria-pressed", k === knop ? "true" : "false"); });
          tbl.querySelectorAll("th[data-kolom]").forEach(function (th) {
            if (!th.hasAttribute("aria-sort")) return;
            th.setAttribute("aria-sort", th.dataset.kolom === kolom ? (op ? "ascending" : "descending") : "none");
          });
          if (status) status.textContent = knop.textContent;
        });
      });

      if (sectie.classList.contains("mvpp-table--tabs")) tabbladen(sectie, tbl);
    });
  }

  /* ---------- tabel op mobiel: één kolom tegelijk ---------- */
  function tabbladen(sectie, tbl) {
    var koppen = Array.prototype.filter.call(tbl.querySelectorAll("thead th[data-kolom]"), function (th) {
      return th.querySelector("img");
    });
    if (!koppen.length) return;
    var balk = document.createElement("div");
    balk.className = "mvpp-tabs";
    balk.setAttribute("role", "tablist");
    var noot = document.createElement("p");
    noot.className = "mvpp-tabs__noot";

    function kies(i) {
      var kolom = koppen[i].dataset.kolom;
      balk.querySelectorAll("button").forEach(function (b, j) { b.setAttribute("aria-selected", j === i ? "true" : "false"); });
      Array.prototype.forEach.call(tbl.tBodies[0].rows, function (r) {
        Array.prototype.forEach.call(r.cells, function (c, j) { c.classList.toggle("is-actief", String(j) === kolom); });
      });
      var label = koppen[i].querySelector(".mvpp-tbl__kolom");
      var tekst = koppen[i].querySelector(".mvpp-tbl__noot");
      noot.innerHTML = "";
      if (label) {
        var sterk = document.createElement("strong");
        sterk.textContent = label.textContent + ". ";
        noot.appendChild(sterk);
      }
      if (tekst) noot.appendChild(document.createTextNode(tekst.textContent));
    }

    koppen.forEach(function (th, i) {
      var knop = document.createElement("button");
      knop.type = "button";
      knop.setAttribute("role", "tab");
      var img = th.querySelector("img").cloneNode(true);
      img.removeAttribute("srcset");
      img.setAttribute("sizes", "20vw");
      knop.appendChild(img);
      var span = document.createElement("span");
      var label = th.querySelector(".mvpp-tbl__kolom");
      span.textContent = label ? label.textContent : "";
      knop.appendChild(span);
      knop.addEventListener("click", function () { kies(i); });
      balk.appendChild(knop);
    });
    var schuif = sectie.querySelector(".mvpp-table__schuif");
    schuif.parentNode.insertBefore(balk, schuif);
    schuif.parentNode.insertBefore(noot, schuif);
    sectie.classList.add("heeft-tabs");
    kies(0);
  }

  /* ---------- keuzehulp ---------- */
  function quiz(root) {
    root.querySelectorAll("[data-mvpp-quiz]").forEach(function (q) {
      if (q.dataset.mvppInit) return;
      q.dataset.mvppInit = "1";
      var groepen = q.querySelectorAll(".mvpp-quiz__vraag");
      var stand = q.querySelector("[data-stand]");
      var product = q.querySelector("[data-product]");
      var uitleg = q.querySelector("[data-uitkomst-tekst]");
      var knopA = q.querySelector("[data-knop-a]");
      var knopB = q.querySelector("[data-knop-b]");
      var knopAlt = q.querySelector("[data-knop-alt]");

      function toon() {
        var gekozen = [];
        groepen.forEach(function (g) {
          var i = g.querySelector("input:checked");
          if (i) gekozen.push(i);
        });
        var open = groepen.length - gekozen.length;
        if (open > 0) {
          stand.textContent = open === 1 ? q.dataset.een : (q.dataset.veel || "").replace("[n]", open);
          return;
        }
        var naarB = null;
        gekozen.forEach(function (i) { if (i.hasAttribute("data-b")) naarB = i; });
        stand.textContent = q.dataset.klaar;
        product.textContent = naarB ? q.dataset.bNaam : q.dataset.aNaam;
        uitleg.textContent = naarB ? naarB.dataset.uitleg
          : gekozen.map(function (i) { return i.dataset.uitleg; }).filter(Boolean).join(" ");
        if (knopA) knopA.hidden = !!naarB;
        if (knopB) knopB.hidden = !naarB;
        if (knopAlt) knopAlt.hidden = !!naarB || !gekozen.some(function (i) { return i.hasAttribute("data-alt"); });
      }
      q.addEventListener("change", toon);
    });
  }

  /* ---------- maatwijzer ---------- */
  function maatwijzer(root) {
    root.querySelectorAll("[data-mvpp-size]").forEach(function (m) {
      if (m.dataset.mvppInit) return;
      m.dataset.mvppInit = "1";
      var bron = m.querySelector("[data-mvpp-size-data]");
      var data;
      try { data = JSON.parse(bron.textContent); } catch (e) { return; }
      var label = m.querySelector("[data-label]");
      var maat = m.querySelector("[data-maat]");
      var tekst = m.querySelector("[data-tekst]");
      var knopA = m.querySelector("[data-knop-a]");
      var knopB = m.querySelector("[data-knop-b]");
      var cupsA = {}, maxBandA = 0;
      Object.keys(data.a).forEach(function (k) {
        var d = k.split("|");
        cupsA[d[1]] = true;
        maxBandA = Math.max(maxBandA, parseFloat(d[0]) || 0);
      });

      function gekozen(soort) {
        var i = m.querySelector('input[name$="-' + soort + '"]:checked');
        return i ? i.value : "";
      }
      function toon() {
        var band = gekozen("band"), cup = gekozen("cup"), sleutel = band + "|" + cup, wie = band + cup;
        var a = data.a[sleutel], b = data.b[sleutel];
        if (knopA) knopA.hidden = true;
        if (knopB) knopB.hidden = true;
        maat.classList.remove("is-klein");
        if (a) {
          label.textContent = data.aLabel;
          maat.textContent = a;
          tekst.textContent = (data.aFor || "").replace("[size]", wie);
          if (knopA) knopA.hidden = false;
        } else if (b) {
          var reden = !cupsA[cup] ? data.redenCup
            : (parseFloat(band) > maxBandA ? data.redenBand : (data.redenAnders || "").replace("[size]", wie));
          label.textContent = data.bLabel;
          maat.textContent = data.bNaam;
          maat.classList.add("is-klein");
          tekst.textContent = [reden, (data.bTekst || "").replace("[fit]", b).replace("[size]", wie)].filter(Boolean).join(" ");
          if (knopB) knopB.hidden = false;
        } else {
          label.textContent = data.aLabel;
          maat.textContent = "?";
          tekst.textContent = data.geen || "";
        }
      }
      m.addEventListener("change", toon);
      toon();
    });
  }

  function start(root) {
    kaarten(root);
    balken(root);
    tabel(root);
    quiz(root);
    maatwijzer(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { start(document); });
  } else {
    start(document);
  }

  /* theme editor: opnieuw starten na herladen, een ingeklapte kaart tonen als je hem kiest */
  document.addEventListener("shopify:section:load", function (e) { start(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var kaart = e.target.closest && e.target.closest("[data-mvpp-extra]");
    if (kaart) zetUitgeklapt(kaart.closest("[data-mvpp-cards]"), true);
  });
})();
